<template>
  <section class="game-selection">
    <ul class="unlock-count">
      <li
        class="lock"
        :class="{ unlocked: isGameUnlocked(g.id) }"
        v-for="g in sortedGames"
        :key="g.id"
      />
    </ul>

    <CJScrollView class="dark" supress="x">
      <div class="container">
        <h1 class="lets-play">Let's Play!</h1>
        <h4>Pick a game!</h4>

        <CJGameList :games="games" @selected="playUnlocked" />

        <div class="candy-bar spinning" v-if="games.length" />
      </div>
    </CJScrollView>
  </section>
</template>

<script>
import { sort } from "ramda";
import { mapGetters } from "vuex";

import CJScrollView from "@/components/CJScrollView";
import CJGameList from "@/components/CJGameList";

export default {
  name: "GameSelection",

  components: { CJScrollView, CJGameList },

  async created() {
    await this.$store.dispatch("loadGames");
    await this.$store.dispatch("unlockAll");
  },

  computed: {
    ...mapGetters(["games", "isGameUnlocked"]),

    sortedGames() {
      return sort((g) => (this.isGameUnlocked(g.id) ? -1 : 1), this.games);
    },
  },

  methods: {
    async playUnlocked(id) {
      if (!this.isGameUnlocked(id)) return;
      if (window.innerWidth <= 768 && id == "grand-slam") {
        window.open("/arcade/games/d6784389/index.htm", "_blank");
      } else {
        this.$router.replace("/game/" + id);
      }
    },
  },
};
</script>

<style lang="stylus">
section.game-selection
  .ps__rail-y
    right: 6px !important
</style>

<style lang="stylus" scoped>
section.game-selection
  display: flex
  flex-direction: column
  font-family: 'Futura Std Condensed'
  font-weight: 700
  font-size: 18px
  height: 100%
  overflow: hidden

  ul.unlock-count
    box-sizing: border-box
    list-style-type: none
    margin: 14px 0
    padding: 0 22px
    display: flex
    justify-content: flex-end
    align-self: right
    width: 100%

    > li.lock + li.lock
      margin-left: 6px

    > li
      margin-top: 2px

      &.unlocked
        margin-top: 0

  .cj-scrollview
    height: 100%

    > .container
      display: flex
      flex-direction: column
      align-items: center

      h1.lets-play
        flex: none
        margin: 0

      h4
        font-size: 26px
        text-transform: uppercase
        margin: 1rem 0 2rem

  .candy-bar
    position: static
    flex: none
    width: 370px
    height: 15px
    transform: translate(1px, 0)

    @media screen and (min-device-width: 1024px)
      width: 100%
</style>
